import { startsWith } from 'ramda';
import { memoize } from './memoize';

export const isSafari10 = memoize((userAgent: string) => {
  const [, version = '', browser = ''] = userAgent.match(/Version\/([\d\.]+).(Safari)/) || [];

  return startsWith('10.', version) && browser === 'Safari';
});

export const isSafari =
  navigator.vendor.match(/apple/i) && !navigator.userAgent.match(/crios/i) && !navigator.userAgent.match(/fxios/i);
